var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89929 15.7C2.26332 15.8556 2.66579 15.8978 3.05419 15.8213C3.44259 15.7447 3.79889 15.5528 4.07662 15.2707L7.99994 11.3687L11.9233 15.2707C12.1062 15.4563 12.3241 15.6037 12.5645 15.7045C12.8047 15.8054 13.0627 15.8575 13.3233 15.858C13.5911 15.8572 13.8562 15.8035 14.1033 15.7C14.4703 15.5515 14.784 15.2957 15.0034 14.9662C15.2229 14.6366 15.3378 14.2485 15.3333 13.8527V3.33333C15.3322 2.44961 14.9807 1.60237 14.3558 0.97748C13.7309 0.352588 12.8837 0.00105857 11.9999 0H3.99995C3.11623 0.00105857 2.26899 0.352588 1.6441 0.97748C1.01921 1.60237 0.66768 2.44961 0.66662 3.33333V13.8527C0.662319 14.2489 0.777673 14.6371 0.9976 14.9667C1.21752 15.2963 1.53178 15.5519 1.89929 15.7Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.1106c5168d17a225cd2c4f9771332084.svg";
export { ForwardRef as ReactComponent };